module.exports = __webpack_public_path__ + "static/media/spotify.16e6d79a.png";